var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map (8) 1",
    clipPath: "url(#clip0_15_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8965 0C22.7952 0 19.459 3.33625 19.459 7.4375C19.459 11.254 25.426 18.0136 26.106 18.7722C26.3079 18.9954 26.5947 19.125 26.8965 19.125C27.1982 19.125 27.4851 18.9954 27.687 18.7722C28.367 18.0136 34.334 11.254 34.334 7.4375C34.334 3.33625 30.9977 0 26.8965 0ZM26.8965 10.625C25.137 10.625 23.709 9.197 23.709 7.4375C23.709 5.678 25.137 4.25 26.8965 4.25C28.656 4.25 30.084 5.678 30.084 7.4375C30.084 9.197 28.656 10.625 26.8965 10.625Z",
    fill: "#EB691E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.00123 12.4823C0.599609 12.6438 0.333984 13.0348 0.333984 13.4704V32.9375C0.333984 33.2903 0.510359 33.6196 0.801484 33.8172C0.979984 33.9362 1.18611 34 1.39648 34C1.53036 34 1.66423 33.9745 1.79173 33.9235L10.959 30.2558V8.5L1.00123 12.4823Z",
    fill: "#EB691E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.268 20.1918C28.6645 20.8633 27.7996 21.25 26.8965 21.25C25.9934 21.25 25.1285 20.8633 24.525 20.1918C24.3082 19.9516 24.0299 19.635 23.709 19.2589V34L33.6667 30.0178C34.0705 29.8584 34.334 29.4653 34.334 29.0318V13.4109C32.5936 16.3583 30.2667 19.0783 29.268 20.1918Z",
    fill: "#EB691E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0034 10.4678L13.084 8.5V30.2558L21.584 33.6558V16.592C20.2261 14.7624 18.8087 12.5588 18.0034 10.4678Z",
    fill: "#EB691E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map_icon.f395f383ae590840d854d816c9418439.svg";
export { ForwardRef as ReactComponent };